import { useState } from "react";
import { Phone, Menu, X, Feather } from "lucide-react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Before & After", href: "#before-after" },
  { label: "Why IMR", href: "#why-imr" },
  { label: "Industry", href: "#industry" },
  { label: "Newsletter", href: "#newsletter" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/85 border-b border-[#D8E2DC]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-full bg-[#1B4332] flex items-center justify-center">
            <Feather className="w-4.5 h-4.5 text-[#D4AF37]" size={18} />
          </span>
          <span className="font-display font-extrabold text-lg tracking-tight text-[#081C15]">
            IMR <span className="text-[#1B4332] font-bold">Poultry Solutions</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-[#2D3748] hover:text-[#1B4332] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+19709023321"
            data-testid="nav-call-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#1B4332] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#081C15] transition-colors duration-200"
          >
            <Phone size={15} />
            1-970-902-3321
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 text-[#1B4332]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#D8E2DC] bg-white px-5 py-4 flex flex-col gap-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-[#2D3748] py-1"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
          <a
            href="tel:+19709023321"
            data-testid="nav-mobile-call-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#1B4332] text-white px-5 py-2.5 text-sm font-semibold w-fit"
          >
            <Phone size={15} />
            1-970-902-3321
          </a>
        </div>
      )}
    </header>
  );
};
